export enum Direction {
    Up,
    Down,
    Left,
    Right,
}
